import { QueryClient } from 'react-query'
 
export const queryClient = new QueryClient()